import * as React from 'react';
import Link from 'components/Link';
import Image from 'components/Image';
import { WithRouterProps, withRouter } from 'react-router';
// @ts-ignore
import { withDocumentTitle } from 'lib/documentTitle';
import Button from 'components/Button';
import Container from 'components/Container';
import Row from 'components/Row';
import TitleHeader from 'components/TitleHeader';
import { Pick2 } from 'types/typescript/util';

import './styles/ScheduledMaintenancePage.scss';

type Props = {
  subtext: string | React.ReactElement;
  contactUsRoute: string;
  className?: string;
};

type RouterProps = Pick2<WithRouterProps, 'router', 'goBack' | 'replace'>;

function ScheduledMaintenancePage(props: Props & RouterProps) {
  const goBack = () => {
    if (window.history.length > 1) {
      props.router.goBack();
    } else {
      props.router.replace('/');
    }
  };

  return (
    <Container size="large" className={props.className}>
      <Row>
        <Image src={require('assets/images/coaching/completed_illustration.svg')} width="100%" />
      </Row>
      <TitleHeader
        title="We're undergoing scheduled maintenance."
        subtext={props.subtext}
        action={
          <div className="ScheduledMaintenancePage-actions">
            <Button href={props.contactUsRoute} data-test="contact-us-button">
              Contact us
            </Button>

            <Link
              onClick={goBack}
              className="ScheduledMaintenancePage-go_back"
              data-test="go-back-button"
              weight="semibold">
              Go back home
            </Link>
          </div>
        }
      />
    </Container>
  );
}

export { ScheduledMaintenancePage };
export default withRouter(withDocumentTitle('Scheduled Maintenance', ScheduledMaintenancePage));
